import { Preferences } from '@capacitor/preferences'
import * as types from '../mutation-types'

async function setPreference(key, value) {
  return await Preferences.set({ key, value: JSON.stringify(value) });
}

async function getPreference(key) {
  const { value } = await Preferences.get({ key });
  return value ? JSON.parse(value) : null;
}

// state
export const state = {
  isOpen: false,
  websiteID: '',
  supportSessionID: '',
  nutritionistSessionID: ''
}

// getters
export const getters = {
  websiteID: state => state.websiteID,
  supportSessionID: state => state.supportSessionID,
  nutritionistSessionID: state => state.nutritionistSessionID
}

// mutations
export const mutations = {
  [types.SET_WEBSITE_ID](state, websiteID) {
    state.websiteID = websiteID;
  },
  [types.SET_SUPPORT_SESSION_ID](state, sessionID) {
    state.supportSessionID = sessionID;
  },
  [types.SET_NUTRITIONIST_SESSION_ID](state, sessionID) {
    state.nutritionistSessionID = sessionID;
  }
};

// actions
export const actions = {
  async setWebsiteID({ commit }, payload) {
    await setPreference('websiteID', payload.websiteID)
    commit(types.SET_WEBSITE_ID, payload.websiteID);
  },
  async setSupportSessionID({ commit }, sessionID) {
    await setPreference('supportSessionID', sessionID)
    commit(types.SET_SUPPORT_SESSION_ID, sessionID);
  },
  async setNutritionistSessionID({ commit }, sessionID) {
    await setPreference('nutritionistSessionID', sessionID)
    commit(types.SET_NUTRITIONIST_SESSION_ID, sessionID);
  },
  async loadSessionIDs({ commit }) {
    const supportSessionID = await getPreference('supportSessionID');
    const nutritionistSessionID = await getPreference('nutritionistSessionID');
    if (supportSessionID) commit(types.SET_SUPPORT_SESSION_ID, supportSessionID);
    if (nutritionistSessionID) commit(types.SET_NUTRITIONIST_SESSION_ID, nutritionistSessionID);
  }
}